import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { DeskLink } from '@/components/generals/desk-link'
import { ContactDesk } from '@/components/contact/contact-desk'

const Contact: FC = (): ReactNode => {
    return (
        <>
            <Seo
                title='Contact'
                description='Start a job with Maren Okonkwo. Fill in the brief — what the photographs are for, when, and which of the five looks — and get an answer within two working days.'
                ogImage='https://pub-dc2abe5caae44240a6d1913566a75e0f.r2.dev/sections/cutout/cinematic-03.jpg'
            />

            <main className='relative'>
                <ContactDesk />

                <DeskLink href='/about'>← the studio</DeskLink>
            </main>
        </>
    )
}

export default Contact
